<div class="board">
  @if (!project?.id) {
    <app-no-content-stub imageSrc="assets/placeholders/placeholder-tasks.svg">
      <div class="flex max-w-full flex-col items-center gap-2">
        <p class="text-base font-medium text-gray-900 text-center">No tasks</p>
        <p class="text-sm text-gray-600 text-center">Save your project to start adding tasks</p>
      </div>
    </app-no-content-stub>
  } @else {
    <div class="board-area">
      <app-project-board-row [appearance]="tasksAppearance" [project]="project" />

      @for (section of sections; track section.id) {
        <app-project-board-row
          [section]="section"
          [canMoveUp]="!$first"
          [canMoveDown]="!$last"
          [appearance]="tasksAppearance"
        />
      }

      @if (project) {
        <button
          type="button"
          class="mt-3 flex h-16 items-center gap-1 rounded-[4px] px-2 text-secondary-600 cursor-pointer transition-colors hover:bg-gray-100 hover:text-gray-900"
          (click)="addSection()"
        >
          <app-icon name="plus" size="l" />
          Add new section
        </button>
      }
    </div>
  }
</div>
